// client/src/components/influencer/project/modals/ContractRejectModal.js
import React, { useState } from 'react';

function ContractRejectModal({ open, onClose, onConfirm, project }) {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(reason);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <div className="contract-reject-modal">
      <div className="contract-reject-modal__content" onClick={(e) => e.stopPropagation()}>
        {/* X 닫기 버튼 */}
        <button 
          className="contract-reject-modal__close-btn"
          onClick={handleClose}
          disabled={isSubmitting}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '26px',
            lineHeight: '0',
            cursor: 'pointer',
            color: '#666',
            padding: '0',
            margin: '0',
            width: '32px',
            height: '32px',
            borderRadius: '4px',
            transition: 'background 0.2s',
            fontFamily: 'Arial, sans-serif',
            fontWeight: '300'
          }}
          onMouseEnter={(e) => e.target.style.background = '#f3f4f6'}
          onMouseLeave={(e) => e.target.style.background = 'none'}
        >
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'block'
          }}>
            ×
          </span>
        </button>

        {/* 경고 아이콘 */}
        <div className="contract-reject-modal__icon-box">
          <div className="contract-reject-modal__icon">⚠️</div>
        </div>

        {/* 제목 */}
        <h2 className="contract-reject-modal__title">정말 거절하시겠습니까?</h2>
        
        {/* 프로젝트 정보 */}
        {project && (
          <div className="contract-reject-modal__project-info">
            <div className="contract-reject-modal__project-label">프로젝트 번호</div>
            <div className="contract-reject-modal__project-value">{project.projectNumber}</div>
          </div>
        )}

        {/* 메시지 */}
        <div className="contract-reject-modal__message">
          계약을 거절하시면 다시 되돌릴 수 없습니다.<br />
          신중히 결정해주세요.<br />
          잦은 계약 거절 시, 다른 프로젝트 선정에 영향을 미칠 수 있습니다.
        </div>

        {/* 거절 사유 입력 (선택) */}
        <div className="contract-reject-modal__input-group">
          <label className="contract-reject-modal__label">
            거절 사유 (선택)
            <span className="contract-reject-modal__optional"> - 최대 2000자</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 2000) {
                setReason(value);
              }
            }}
            placeholder="거절 사유를 입력해주세요 (선택사항)"
            className="contract-reject-modal__textarea"
            rows={5}
          />
          <div className="contract-reject-modal__char-count">
            {reason.length} / 2000자
          </div>
        </div>

        {/* 버튼 그룹 */}
        <div className="contract-reject-modal__btn-group">
          <button 
            className="contract-reject-modal__btn contract-reject-modal__btn--cancel"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            취소
          </button>
          <button 
            className="contract-reject-modal__btn contract-reject-modal__btn--reject"
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? '처리 중...' : '거절하기'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContractRejectModal;

